/**
 * (c) 2025
 * written by Marco Aveta
 * I-PLAN
 *
 * i18n initialization and dynamic menu rendering
 * Language priority: localStorage > env > default ("it")
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { hasAdministrationRights } from './menu_helper.js';

const language = localStorage.getItem("language") || process.env.REACT_APP_LANGUAGE || "it";

const t = i18n.t;

/**
 * Write user info to UI
 */
const write_user = ({ user }) => {
    const $ = window.$;
    const container = $("#connected-user");
    container.html("");
    container.append($("<h6/>").text(`${user.Name} ${user.LastName}`));
    container.append($("<p/>").text(user.EMail));

    $("#yourNameSubHeaderMenu").html(`<h6>${user.Name} ${user.LastName}</h6>`);
    $("#yourMailSubHeaderMenu").html(`<span>${user.EMail}</span>`);
};

/**
 * Write navigation menu to UI
 */
const write = async ({ user }) => {
    if (user) write_user({ user });

    i18n
        .use(initReactI18next)
        .init({
            lng: language,
            resources: {
                it: {
                    translation: {
                        menu: {
                            main: "Home",
                            modules: "Moduli",
                            dashboard: "Dashboard",
                            dms: {
                                title: "DMS",
                                documents: "Documenti",
                                meets: "Registrazioni meet",
                                root: "Root"
                            },
                            requirements: {
                                title: "Requisiti",
                                list: "Elenco",
                                flows: "Flussi"
                            },
                            indicators: "Indicatori",
                            selfAssessment: {
                                title: "Autovalutazione",
                                poas: "PoA",
                                results: "Risultati"
                            },
                            goals: "Obiettivi",
                            activities: {
                                title: "Attività",
                                boards: "Le tue board"
                            },
                            bfm: "BFM",
                            meets: "Meet",
                            admin: "Admin",
                            usersGroups: {
                                title: "Utenti e gruppi",
                                find: "Cerca",
                                addUser: "Nuovo Utente",
                                addGroup: "nuovo Gruppo"
                            },
                            organization: {
                                title: "Organizzazione",
                                chart: "Organigramma",
                                functional: "Schema funzionale"
                            },
                            vocs: {
                                title: "Voc di sistema",
                                orgRoles: "Voc ruoli organizzativi",
                                funcRoles: "Voc ruoli funzionali",
                                unitTypes: "Voc tipi di unità aziendali",
                                classificationTypes: "Voc classificazioni dms",
                                dmsFilesValidationFlow:"Voc flusso validazione dms"
                            },
                            aiSettings: "Impostazioni AI",
                            aiEditor: "Editor AI"
                        }
                    }
                },
                en: {
                    translation: {
                        menu: {
                            main: "Main",
                            modules: "Modules",
                            dashboard: "Dashboard",
                            dms: {
                                title: "DMS",
                                documents: "Documents",
                                meets: "Meets recordings",
                                root: "Root"
                            },
                            requirements: {
                                title: "Requirements",
                                list: "List",
                                flows: "Flows"
                            },
                            indicators: "Indicators",
                            selfAssessment: {
                                title: "Self assessment",
                                poas: "PoAs",
                                results: "Results"
                            },
                            goals: "Goals",
                            activities: {
                                title: "Activities",
                                boards: "Your boards"
                            },
                            bfm: "BFM",
                            meets: "Meets",
                            admin: "Admin",
                            usersGroups: {
                                title: "Users and groups",
                                find: "Find",
                                addUser: "+ User",
                                addGroup: "+ Group"
                            },
                            organization: {
                                title: "Organization",
                                chart: "Organizational chart",
                                functional: "Functional chart"
                            },
                            vocs: {
                                title: "System vocs",
                                orgRoles: "Organizational roles voc",
                                funcRoles: "Functional roles voc",
                                unitTypes: "Business unit types voc",
                                classificationTypes: "Voc dms classifications",
                                dmsFilesValidationFlow:"Voc validation flow dms"


                            },
                            aiSettings: "AI settings",
                            aiEditor: "AI Editor"
                        }
                    }
                },
                fr: {
                    translation: {
                        menu: {
                            main: "Accueil",
                            modules: "Modules",
                            dashboard: "Tableau de bord",
                            dms: {
                                title: "DMS",
                                documents: "Documents",
                                meets: "Enregistrements Meets",
                                root: "Racine"
                            },
                            requirements: {
                                title: "Exigences",
                                list: "Liste",
                                flows: "Flux"
                            },
                            indicators: "Indicateurs",
                            selfAssessment: {
                                title: "Auto-évaluation",
                                poas: "PoAs",
                                results: "Résultats"
                            },
                            goals: "Objectifs",
                            activities: {
                                title: "Activités",
                                boards: "Vos tableaux"
                            },
                            bfm: "BFM",
                            meets: "Meets",
                            admin: "Admin",
                            usersGroups: {
                                title: "Utilisateurs et groupes",
                                find: "Chercher",
                                addUser: "+ Utilisateur",
                                addGroup: "+ Groupe"
                            },
                            organization: {
                                title: "Organisation",
                                chart: "Organigramme",
                                functional: "Schéma fonctionnel"
                            },
                            vocs: {
                                title: "Voc système",
                                orgRoles: "Voc rôles organisationnels",
                                funcRoles: "Voc rôles fonctionnels",
                                unitTypes: "Voc types d’unités"
                            },
                            aiSettings: "Paramètres IA"
                        }
                    }
                },
                es: {
                    translation: {
                        menu: {
                            main: "Principal",
                            modules: "Módulos",
                            dashboard: "Panel",
                            dms: {
                                title: "DMS",
                                documents: "Documentos",
                                meets: "Grabaciones de Meets",
                                root: "Raíz"
                            },
                            requirements: {
                                title: "Requisitos",
                                list: "Lista",
                                flows: "Flujos"
                            },
                            indicators: "Indicadores",
                            selfAssessment: {
                                title: "Autoevaluación",
                                poas: "PoAs",
                                results: "Resultados"
                            },
                            goals: "Metas",
                            activities: {
                                title: "Actividades",
                                boards: "Tus tableros"
                            },
                            bfm: "BFM",
                            meets: "Meets",
                            admin: "Administrador",
                            usersGroups: {
                                title: "Usuarios y grupos",
                                find: "Buscar",
                                addUser: "+ Usuario",
                                addGroup: "+ Grupo"
                            },
                            organization: {
                                title: "Organización",
                                chart: "Organigrama",
                                functional: "Esquema funcional"
                            },
                            vocs: {
                                title: "Voc del sistema",
                                orgRoles: "Voc roles organizativos",
                                funcRoles: "Voc roles funcionales",
                                unitTypes: "Voc tipos de unidad"
                            },
                            aiSettings: "Configuración IA"
                        }
                    }
                }
            }
        });

    const $ = window.$;
    const is = (urlPart) => window.location.href.includes(urlPart);
    const ends = (urlEnd) => window.location.href.endsWith(urlEnd);

    const menu = $(".metismenu");
    menu.html("");

    // Check user rights
    const userHasAdminRights = hasAdministrationRights(user);

    // Utility to append a menu item
    const addMenuItem = (html) => menu.append(html);

    // Menu sections
    addMenuItem(`<li class="menu-title">${t("menu.main")}</li>`);
    addMenuItem(`
        <li class="${is("/dashboard") ? "mm-active" : ""}">
            <a href="/dashboard" class="${is("/dashboard") ? "mm-active" : ""}">
                <div class="menu-icon"><i class="fa fa-chart-line"></i></div>
                <span class="nav-text">${t("menu.dashboard")}</span>
            </a>
        </li>
    `);

    addMenuItem(`<li class="menu-title">${t("menu.modules")}</li>`);

    // DMS
    addMenuItem(`
        <li>
            <a class="has-arrow" href="#">
                <div class="menu-icon"><i class="fa fa-folder-tree"></i></div>
                <span class="nav-text">${t("menu.dms.title")}</span>
            </a>
            <ul class="mm-collapse ${is("/dms") ? "mm-active mm-show" : ""}">
                <li class="${ends("/dms/documents") ? "mm-active" : ""}"><a href="/dms/documents">${t("menu.dms.documents")}</a></li>
                <li class="${ends("/dms/meets") ? "mm-active" : ""}"><a href="/dms/meets">${t("menu.dms.meets")}</a></li>
                <li class="${ends("/dms") ? "mm-active" : ""}"><a href="/dms">${t("menu.dms.root")}</a></li>
            </ul>
        </li>
    `);

    // Requirements
    addMenuItem(`
        <li>
            <a class="has-arrow" href="#">
                <div class="menu-icon"><i class="fa fa-hand-point-up"></i></div>
                <span class="nav-text">${t("menu.requirements.title")}</span>
            </a>
            <ul class="mm-collapse ${is("/requirements") ? "mm-active mm-show" : ""}">
                <li class="${ends("/requirements") ? "mm-active" : ""}"><a href="/requirements">${t("menu.requirements.list")}</a></li>
                <li class="${ends("/admin/requirements/flows") ? "mm-active" : ""}"><a href="/admin/requirements/flows">${t("menu.requirements.flows")}</a></li>
            </ul>
        </li>
    `);

    // Indicators
    addMenuItem(`
        <li class="${is("/admin/indicators") ? "mm-active" : ""}">
            <a href="/admin/indicators">
                <div class="menu-icon"><i class="fa fa-list-ol"></i></div>
                <span class="nav-text">${t("menu.indicators")}</span>
            </a>
        </li>
    `);

    // Self-assessment
    addMenuItem(`
        <li>
            <a class="has-arrow" href="#">
                <div class="menu-icon"><i class="fa fa-ranking-star"></i></div>
                <span class="nav-text">${t("menu.selfAssessment.title")}</span>
            </a>
            <ul class="mm-collapse ${is("/quality/self-assessment") ? "mm-active mm-show" : ""}">
                <li class="${is("/quality/self-assessment/poas") ? "mm-active" : ""}"><a href="/quality/self-assessment/poas">${t("menu.selfAssessment.poas")}</a></li>
                <li class="${is("/quality/self-assessment/results") ? "mm-active" : ""}"><a href="/quality/self-assessment/results">${t("menu.selfAssessment.results")}</a></li>
            </ul>
        </li>
    `);

    // Goals
    addMenuItem(`
        <li class="${is("/quality/goals") ? "mm-active" : ""}">
            <a href="/dms">
                <div class="menu-icon"><i class="fa fa-bullseye"></i></div>
                <span class="nav-text">${t("menu.goals")}</span>
            </a>
        </li>
    `);

    // Activities
    addMenuItem(`
        <li>
            <a class="has-arrow" href="#">
                <div class="menu-icon"><i class="fa-solid fa-table-columns"></i></div>
                <span class="nav-text">${t("menu.activities.title")}</span>
            </a>
            <ul class="mm-collapse ${is("/activity") ? "mm-active mm-show" : ""}">
                <li class="${ends("/activity/board") ? "mm-active" : ""}"><a href="/activity/board">${t("menu.activities.boards")}</a></li>
            </ul>
        </li>
    `);

    // BFM - Show only if user has administration rights
    if (userHasAdminRights) {
        addMenuItem(`
            <li class="${is("/flowise") ? "mm-active" : ""}">
                <a href="/flowise">
                    <div class="menu-icon"><i class="fa fa-robot"></i></div>
                    <span class="nav-text">${t("menu.bfm")}</span>
                </a>
            </li>
        `);
    }

    // AI Editor
    addMenuItem(`
        <li class="${is("/ai-editor") ? "mm-active" : ""}">
            <a href="/ai-editor">
                <div class="menu-icon"><i class="fa fa-robot"></i></div>
                <span class="nav-text">${t("menu.aiEditor")}</span>
            </a>
        </li>
    `);

    // Meets
    addMenuItem(`
        <li class="${is("/meet") ? "mm-active" : ""}">
            <a href="/meet">
                <div class="menu-icon"><i class="fa fa-tv"></i></div>
                <span class="nav-text">${t("menu.meets")}</span>
            </a>
        </li>
    `);

    // Admin section - Show only if user has administration rights
    if (userHasAdminRights) {
        addMenuItem(`<li class="menu-title">${t("menu.admin")}</li>`);

        // Users & Groups
        addMenuItem(`
            <li>
                <a class="has-arrow" href="#">
                    <div class="menu-icon"><i class="fa fa-users"></i></div>
                    <span class="nav-text">${t("menu.usersGroups.title")}</span>
                </a>
                <ul class="mm-collapse ${is("/admin/user") || is("/admin/group") ? "mm-active mm-show" : ""}">
                    <li class="${is("/admin/users_and_groups") ? "mm-active" : ""}"><a href="/admin/users_and_groups">${t("menu.usersGroups.find")}</a></li>
                    <li class="${ends("/admin/user") ? "mm-active" : ""}"><a href="/admin/user">${t("menu.usersGroups.addUser")}</a></li>
                    <li class="${ends("/admin/group") ? "mm-active" : ""}"><a href="/admin/group">${t("menu.usersGroups.addGroup")}</a></li>
                </ul>
            </li>
        `);

        // Organization
        addMenuItem(`
            <li>
                <a class="has-arrow" href="#">
                    <div class="menu-icon"><i class="fa fa-sitemap"></i></div>
                    <span class="nav-text">${t("menu.organization.title")}</span>
                </a>
                <ul class="mm-collapse ${is("/admin/organization") ? "mm-active mm-show" : ""}">
                    <li class="${is("/admin/organization/business_units") ? "mm-active" : ""}"><a href="/admin/organization/business_units">${t("menu.organization.chart")}</a></li>
                    <li class="${is("/admin/organization/functional_chart") ? "mm-active" : ""}"><a href="/goHome">${t("menu.organization.functional")}</a></li>
                </ul>
            </li>
        `);

        // VOCs
        addMenuItem(`
            <li>
                <a class="has-arrow" href="#">
                    <div class="menu-icon"><i class="fa fa-list"></i></div>
                    <span class="nav-text">${t("menu.vocs.title")}</span>
                </a>
                <ul class="mm-collapse ${is("/admin/vocs") ? "mm-active mm-show" : ""}">
                    <li class="${is("/admin/vocs/organizational_chart_roles") ? "mm-active" : ""}"><a href="/admin/vocs/organizational_chart_roles">${t("menu.vocs.orgRoles")}</a></li>
                    <li class="${is("/admin/vocs/functional_chart_roles") ? "mm-active" : ""}"><a href="/admin/vocs/functional_chart_roles">${t("menu.vocs.funcRoles")}</a></li>
                    <li class="${is("/admin/vocs/business_unit_types") ? "mm-active" : ""}"><a href="/admin/vocs/business_unit_types">${t("menu.vocs.unitTypes")}</a></li>
                    <li class="${is("/admin/vocs/dms_classification_types") ? "mm-active" : ""}"><a href="/admin/vocs/dms_classification_types">${t("menu.vocs.classificationTypes")}</a></li>
                    <li class="${is("/admin/vocs/dms_files_validation_flow") ? "mm-active" : ""}"><a href="/admin/vocs/dms_files_validation_flow">${t("menu.vocs.dmsFilesValidationFlow")}</a></li>


                </ul>
            </li>
        `);

        // AI Settings
        addMenuItem(`
            <li>
                <a href="/dms">
                    <div class="menu-icon"><i class="fa fa-brain"></i></div>
                    <span class="nav-text">${t("menu.aiSettings")}</span>
                </a>
            </li>
        `);
    }

    // Reinitialize MetisMenu
    menu.metisMenu("dispose");
    menu.metisMenu();
};

export {
    write,
    write_user,
    i18n,
    t
};
